export type ClingCharacterId = 'classic' | 'sky' | 'ruby' | 'slate';

export interface ClingCharacterDef {
  id: ClingCharacterId;
  label: string;
  /** Filtro CSS sobre espiritumusical.png */
  filter: string;
  bg: string;
}

export const CLING_CHARACTERS: ClingCharacterDef[] = [
  {
    id: 'classic',
    label: 'Espíritu clásico',
    filter: 'none',
    bg: 'linear-gradient(160deg, #dbeafe 0%, #bfdbfe 100%)',
  },
  {
    id: 'sky',
    label: 'Espíritu cielo',
    filter: 'hue-rotate(185deg) saturate(1.2) brightness(1.05)',
    bg: 'linear-gradient(160deg, #e0f2fe 0%, #bae6fd 100%)',
  },
  {
    id: 'ruby',
    label: 'Espíritu rubí',
    filter: 'hue-rotate(-28deg) saturate(1.35) brightness(1.02)',
    bg: 'linear-gradient(160deg, #ffe4e6 0%, #fecdd3 100%)',
  },
  {
    id: 'slate',
    label: 'Espíritu luna',
    filter: 'saturate(0.35) brightness(1.12) contrast(1.05)',
    bg: 'linear-gradient(160deg, #f1f5f9 0%, #e2e8f0 100%)',
  },
];

const STORAGE_KEY = 'cling-character';

export function loadClingCharacter(): ClingCharacterId {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'classic' || raw === 'sky' || raw === 'ruby' || raw === 'slate') return raw;
  } catch {
    /* ignore */
  }
  return 'classic';
}

export function saveClingCharacter(id: ClingCharacterId): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}

export function getClingCharacter(id: ClingCharacterId): ClingCharacterDef {
  return CLING_CHARACTERS.find((c) => c.id === id) ?? CLING_CHARACTERS[0]!;
}
